

export const taxCalculator = (total, tax) => {
    return parseFloat(total * tax) / 100;
}

export const finalAMT = (base, tax1, tax2) => {
    const tx = parseFloat(tax1) + parseFloat(tax2);
    const f = parseFloat(base) + parseFloat(tx);
    return f
}

export const capitalizeFirstLetter = (str)=> {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }